import { createSelector } from 'reselect';

import type { RootState } from 'config/store/reducers';

const getRoot = (state: RootState) => state;

const getState = createSelector(getRoot, (state) => state.refdata);

export const getRefDataMedia = createSelector(getState, (refdata) => refdata.media ?? {});
